import ClipIcon from 'assets/icons/clip.svg'
import { Spinner } from 'components/uikit/Spinner'
import { useDownloadFile } from 'hooks/useDownloadFile'
import { AwardsAttachments } from 'types/AwardsAttachments'
import { AwardsFile } from 'types/AwardsFile'

import { removeHTML } from '../contentAccordion/ContentAccordion'
interface DetailsProps {
  info: AwardsFile
  attachments: AwardsAttachments
  loading: boolean
}

const questions = {
  category: '<p>Which TCCC product category or function is this for?</p>',
  brand: 'What TCCC Brand is this for?',
  ouOrigin: 'Which OU are you submitting from?',
  ouLive: 'Which OU(s) does this work live in?',
  members: 'Team Members',
  liveDate: 'When did this work go live?',
}

export const DetailsComponent = ({ info, attachments, loading }: DetailsProps) => {
  const downloadFile = useDownloadFile()
  const getField = (question: string) => {
    return info.data?.fields
      ?.filter(el => el.label.toLowerCase().includes(question.toLowerCase()))[0]
      ?.value?.toString()
  }
  const members = removeHTML(getField(questions.members))?.split(',')

  const fileAttachments = attachments?.attachments?.filter(el => !['image', 'video'].includes(el.type || ''))
  const liveDate: any = info.data?.fields?.filter(el => el.label.includes(questions.liveDate))[0].value
  return (
    <div className="bg-[#FAFAFA] flex flex-col w-full rounded-3xl p-4 font-TCCC text-xs">
      <div className="flex w-full">
        <div className="w-1/2 flex flex-wrap justify-between border-solid border-r border-[#D7D7D7] pr-6 py-4 text-[12px] break-words">
          <h3 className="font-bold text-[16px] pb-4 w-full">General specs</h3>
          <div className="flex flex-col w-1/2">
            <p className="font-bold">NMA Category</p>
            <p>{info.category}</p>
          </div>
          {getField(questions.ouOrigin) && (
            <div className="flex flex-col w-1/2 pr-1">
              <p className="font-bold">OU submitting</p>
              <p>{getField(questions.ouOrigin)}</p>
            </div>
          )}
          {getField(questions.category) && (
            <div className="flex flex-col w-1/2 pr-1">
              <p className="font-bold">Product Category</p>
              <p>{getField(questions.category)}</p>
            </div>
          )}
          {getField(questions.ouLive) && (
            <div className="flex flex-col w-1/2 pr-1">
              <p className="font-bold">OU(s) live in</p>
              <p className="break-words">{getField(questions.ouLive)?.replaceAll(',', ', ')}</p>
            </div>
          )}
          {getField(questions.brand) && (
            <div className="flex flex-col w-1/2 pr-1">
              <p className="font-bold">Brand</p>
              <p>{getField(questions.brand)}</p>
            </div>
          )}
          <div className="flex flex-col w-1/2 pr-1">
            <p className="font-bold">Live date</p>
            <p>{liveDate?.date}</p>
          </div>
        </div>
        <div className="w-1/2 flex flex-col px-6 py-4 overflow-hidden">
          <h3 className="font-bold text-[16px] pb-4 ">Team Members</h3>
          <h4 className="font-bold">Submitted by</h4>
          <p className="mb-4">
            {info.entrantFirstName} {info.entrantLastName}
          </p>
          {!members || members.length === 1 ? (
            <p>{members[0]}</p>
          ) : (
            <ul className="list-disc max-h-[200px] max-w-[120px] gap-[0_60px] whitespace-nowrap">
              {members?.map(member => <li key={member}>{member}</li>)}
            </ul>
          )}
        </div>
      </div>
      {(loading || fileAttachments?.length > 0) && (
        <div className="w-full border-solid border-t border-[#D7D7D7] py-4">
          <h3 className="text-[18px] font-semibold mb-5">Documents</h3>
          <div className="flex flex-wrap gap-y-2">
            {loading && <Spinner className="size-4" color="#505050" />}

            {fileAttachments?.map(el => (
              <button
                className="flex justify-between items-center h-10 bg-[#505050] text-white p-[11px] rounded-6 mr-4 gap-2"
                onClick={() => downloadFile(el.url, el.filename)}
              >
                <img src={ClipIcon} className="h-4" alt="" />
                <span>{el.filename}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
